// TODO: Add support for other browsers if needed
export const detectBrowser = () => {
  let isSafari = false

  if ((navigator as any).userAgentData) {
    isSafari = (navigator as any).userAgentData?.brands?.some(
      (brand: { brand: string; version: string }) =>
        brand.brand === 'Apple' && brand.version,
    )
  } else {
    isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }
  return {
    isSafari,
  }
}
